import React from 'react';
import { Dialog, DialogContent } from '@shared/ui/dialog';
import { ComplaintDetails } from './ComplaintDetails';
import { TransferDetails } from './TransferDetails';
import { ServiceDetails } from './ServiceDetails';
import { ReconnectionDetails } from './ReconnectionDetails';
import { DisconnectionDetails } from './DisconnectionDetails';

interface RequestDetailsModalProps {
  isOpen: boolean;
  onClose: () => void;
  requestData: any;
}

export const RequestDetailsModal = ({ isOpen, onClose, requestData }: RequestDetailsModalProps) => {
  if (!requestData) return null;
  console.log('request data is',requestData)

  const type = requestData.requestType?.toLowerCase() || '';

    console.log('request type is',type  )


  const renderContent = () => {
    if (type.includes('complaint')) return <ComplaintDetails data={requestData} />;
    if (type.includes('transfer')) return <TransferDetails data={requestData} />;
    if (type.includes('service')) return <ServiceDetails data={requestData} />;
    if (type.includes('reconnection')) return <ReconnectionDetails data={requestData} />;
    if (type.includes('disconnect permanent')) return <DisconnectionDetails data={requestData} />;
    return <div className="p-6">Unknown Request Type</div>;
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto p-0 gap-0">
        {renderContent()}
      </DialogContent>
    </Dialog>
  );
};
